module.exports = __webpack_public_path__ + "img/Slider-IMMO_fr.bbd9856d.png";